import { render, staticRenderFns } from "./mun.vue?vue&type=template&id=08ac741c&scoped=true"
import script from "./mun.vue?vue&type=script&lang=js"
export * from "./mun.vue?vue&type=script&lang=js"
import style0 from "./mun.vue?vue&type=style&index=0&id=08ac741c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac741c",
  null
  
)

export default component.exports